import { useMemo } from 'react';

import { EmojiResource } from '@atlaskit/emoji/resource';
import type { OptionalEmojiDescriptionWithVariations } from '@atlaskit/emoji';

import { createEmojiProviderParameters } from '@confluence/fabric-emoji-support';
import { expVal } from '@confluence/feature-experiments';
import { getEmojiNodeDataProvider } from '@confluence/fabric-providers/entry-points/EmojiProvider';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData';

export function useEmojiNodeDataProvider() {
	const { userId, cloudId, isLicensed, isLoggedIn } = useSessionData();

	// We need a special emoji parameters that supports SSR load optimization here.
	const emojiResourceParams = useMemo(() => {
		return createEmojiProviderParameters({
			cloudId,
			userId,
			isLicensed,
			isLoggedIn,
		});
	}, [cloudId, userId, isLicensed, isLoggedIn]);

	if (!expVal('platform_editor_emoji_otp', 'isEnabled', false)) {
		return undefined;
	}

	const emojiNodeDataProvider = getEmojiNodeDataProvider(EmojiResource, {
		...emojiResourceParams,
		allowAnonymousAccess: true,
	});

	if (emojiNodeDataProvider) {
		const ssrProvidersData: {
			emojiNodeDataProvider?: Record<string, OptionalEmojiDescriptionWithVariations>;
		} = window['__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__'] || {};
		const ssrData = ssrProvidersData['emojiNodeDataProvider'];

		emojiNodeDataProvider.setSSRData(ssrData);
	}

	return emojiNodeDataProvider;
}
